import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Card } from '@beef/smart-kit';
import { Picture } from 'components';
import { Text } from '@beef/ui-kit';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const ExtraActiveBlock = ({ title, description, icon }) => (
  <Card className={cx('block-wrapper')} withHover>
    {title
      && (
        <div className={cx('block-wrapper__title')}>
          <Text size="size5-m">{title}</Text>
        </div>
      )}
    {description
      && (
        <Text size="size6-r" color="grey60">
          {description}
        </Text>
      )}
    {icon
      && (
        <Picture
          defaultImage={icon}
          className={cx('block-wrapper__icon')}
          alt=""
        />
      )}
  </Card>
);

ExtraActiveBlock.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
};

export { ExtraActiveBlock };
